'use client';
import FilledStarIcon from '../Icons/FilledStar';
import HalfStarIcon from '../Icons/HalfStart';
import EmptyStarIcon from '../Icons/EmptyStar';

import {IExperienceDictionary} from '@/dictionaries/pages/experience/types';

type Props = {
  dict: IExperienceDictionary;
  averageScore: number;
  countReviews: number;
};

export default function ExperienceRating({
  dict,
  averageScore,
  countReviews,
}: Props) {
  const stars = [];
  const isInteger = averageScore % 1 === 0;

  for (let i = 1; i <= 5; i++) {
    if (isInteger && i <= averageScore) {
      stars.push(
        <div key={i} className="inline-block mr-[5px]">
          <FilledStarIcon className="fill-current text-inherit w-6 h-6" />
        </div>,
      );
    } else if (!isInteger && i < averageScore) {
      stars.push(
        <div key={i} className="inline-block mr-[5px]">
          <FilledStarIcon className="fill-current text-inherit w-6 h-6" />
        </div>,
      );
    } else if (!isInteger && i === Math.ceil(averageScore)) {
      stars.push(
        <div key={i} className="inline-block mr-[5px]">
          <HalfStarIcon className="fill-current text-inherit w-6 h-6" />
        </div>,
      );
    } else {
      stars.push(
        <div key={i} className="inline-block mr-[5px]">
          <EmptyStarIcon className="fill-current text-inherit w-6 h-6" />
        </div>,
      );
    }
  }

  const scrollToElement = (id: string) => {
    const element = document.getElementById(id);

    if (element) {
      const topOffset = element.offsetTop - 80;
      window.scrollTo({top: topOffset, behavior: 'smooth'});
    }
  };

  return (
    <div className="text-base flex items-center">
      <div className="flex mr-2 text-primary">{stars}</div>
      <span
        className="text-gray-700 cursor-pointer"
        onClick={() => scrollToElement('reviews')}>
        {`${countReviews} ${dict.reviews}`}
      </span>
    </div>
  );
}
